import { React } from 'react';
import './styles/products.scss';
import LimitedMain from './components/hero-items/LimitedMain';
import { motion } from 'framer-motion';
import Pengu from './components/Pengu';
import ReactGA from 'react-ga';

const Products = () => (
        <div className="products-container">
            <LimitedMain />
            <div className="game-container">
                <div className="le-container">
                    <img src="./img/glamshots/DE.png" alt="" />
                </div>
                <div className="product-container">
                    <div className="DE-container">
                        <div className="glamshot-container">
                            <img src="./img/glamshots/DeluxeEdition_NISClassic1-NSW-ESRB_1.jpeg" alt="Limited Edition Glamshot" />
                        </div>
                    </div>
                    <div className="product-links">
                        <h1 className="product-tag">
                            Purchase Now!
                        </h1>
                        <div className="product-buttons">
                            <a href="https://www.amazon.ca/Prinny-Presents-Nis-Classics-Nintendo/dp/B08YQR69FZ"target="_blank" rel="noreferrer"
                                onClick={
                                    ()=>{
                                        ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'NISA / Preorder Prinny Presents Vol 1: Phantom Brave / Soul Nomad / SE / Amazon'
                                          })
                                    }
                                }
                            >
                                <button className="store-link">
                                    Amazon
                                </button>
                            </a>
                            <a href="https://www.amazon.ca/Prinny-Presents-Nis-Classics-Nintendo/dp/B08YQR69FZ"
                                onClick={
                                    ()=>{
                                        ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'NISA / Preorder Prinny Presents Vol 1: Phantom Brave / Soul Nomad / SE / Amazon CA'
                                          })
                                    }
                                }
                            >
                                <button className="store-link">
                                    Amazon (CA)
                                </button>
                            </a>
                            <a href="https://www.bestbuy.com/site/prinny-presents-nis-classics-volume-1-nintendo-switch/6456973.p?skuId=6456973"target="_blank" rel="noreferrer"
                                onClick={
                                    ()=>{
                                        ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'NISA / Preorder Prinny Presents Vol 1: Phantom Brave / Soul Nomad / SE / Best Buy'
                                          })
                                    }
                                }
                            >
                                <button className="store-link">
                                    Best Buy
                                </button>
                            </a>
                            <a href="https://www.gamestop.com/products/prinny-presents-nis-classic-volume-1-deluxe-edition/11122617.html" target="_blank" rel="noreferrer"                                onClick={
                                    ()=>{
                                        ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'NISA / Preorder Prinny Presents Vol 1: Phantom Brave / Soul Nomad / SE / Game Stop'
                                          })
                                    }}>
                                <button className="store-link">
                                    GameStop
                                </button>
                            </a>
                            <a href="https://www.ebgames.ca/Switch/Games/881308/prinny-presents-nis-classics-volume-1-phantom-brave-the-hermuda-triangle-remastered-soul-nomad-and-the-world-eaters-deluxe-edition-nintendo-switch"target="_blank" rel="noreferrer"
                                onClick={
                                    ()=>{
                                        ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'NISA / Preorder Prinny Presents Vol 1: Phantom Brave / Soul Nomad / SE / EB Games'
                                          })
                                    }}
                            >
                                <button className="store-link">
                                    EB Games
                                </button>
                            </a>
                            <a href="https://www.target.com/p/prinny-presents-nis-classics-volume-1-phantom-brave-the-hermuda-triangle-remastered-soul-nomad-38-the-world-eaters-nintendo-switch/-/A-82614567" target="_blank" rel="noreferrer"
                                onClick={
                                    ()=>{
                                        ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'NISA / Preorder Prinny Presents Vol 1: Phantom Brave / Soul Nomad / SE / Target'
                                          })
                                    }}
                            >
                                <button className="store-link">
                                    Target
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <motion.div className="spin-prin"
                initial={{x: "100%"}}
                transition={{delay: 2, duration: 2}}
                animate={{x: 0}}
            >
                <a href="https://nisamerica.com/nis-classics/vol-2/" target="_blank" rel="noreferrer">
                    <img classname="prinny" src="./img/teaser-type/prinny_spin.gif" alt="spinning-prinny"/>
                </a>
            </motion.div>
            <Pengu link="https://store.nisamerica.com/prinny-presents-nis-classics-volume-1-phantom-brave-soul-nomad"/>
        </div>
);


export default Products;